import React from 'react'
import PropTypes from 'prop-types'
import { Select } from 'antd'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { countries } from '../../constant'

const CountryChange = ({ customCountries, disabled=false, defaultValue, reload = false }) => {
  const { i18n, t } = useTranslation()
  const navigate = useNavigate()

  const changeLanguage = (selectedLocale) => {
    i18n.changeLanguage(selectedLocale)

    localStorage.setItem('new_locale', selectedLocale)

    window?.OneTrust?.changeLanguage(selectedLocale.split('-')[0])

    if (reload) {
      navigate('/')
    }
  }

  const countryList = customCountries || countries
  const countryOptions = countryList.map((country) => ({
    label: (
      <span className="list-none">
        <img alt={country.name} className="language-selector-image" src={country.flag} width="40px" />{' '}
        {country.name}
      </span>
    ),
    value: country.locale,
  }))

  return (
    <Select
      className="countrySelectorList"
      disabled={disabled}
      name="country"
      onChange={(selected) => changeLanguage(selected)}
      options={countryOptions}
      placeholder={t('selectCountry')}
      value={defaultValue || undefined}
    />
  )
}

CountryChange.propTypes = {
  customCountries: PropTypes.array,
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
  reload: PropTypes.bool,
}

export default CountryChange
